export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7614.69d20005.jpg";